import moment from "moment";
import { useData } from "../../../context/GetDataContext";
import { useUpdateForm } from "../../../context/UpdateFormContext";
import { useEffect, useState } from "react";
import { getRouteDistance } from "../../../utils/getDistance";
import { isEmpty } from "lodash";

const LoadPickAndDelivery = () => {
  const { data } = useData();
  const { updateData } = useUpdateForm();
  const [atPickup, setAtPickup] = useState<any>([]);
  const [hookedTrailer, setHookTrailer] = useState<any>([]);
  const [loadingComplete, setLoadingComplete] = useState<any>([]);
  const [AtDelivery, setAtDelivery] = useState<any>([]);
  const [delivered, setDelivered] = useState<any>([]);
  const [unHook, setUnHook] = useState<any>([]);
  const [pickTrailer, setPickTrailer] = useState<any>([]);

  const [distanceMiles, setDistanceMiles] = useState<string | null>(null);
  const [yardtoPichup, setYardtoPichup] = useState<string | null>(null);

  const handleClick = (e: any) => {
    updateData(e);
  };

  useEffect(() => {
    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "At Pickup",
      );
      setAtPickup(findData);
    }
    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "Hooked Trailer",
      );
      setHookTrailer(findData);
    }
    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "Loading Completed",
      );
      setLoadingComplete(findData);
    }
    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "At Delivery",
      );
      setAtDelivery(findData);
    }

    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "Unhook Trailer",
      );
      setUnHook(findData);
    }
    if (data?.load_status) {
      const findData = data?.load_status?.filter(
        (item: any) => item?.status === "Pick Empty Trailer",
      );
      setPickTrailer(findData);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmpty(atPickup)) {
      const yard = {
        lat: Number(data?.terminal?.lat),
        lng: Number(data?.terminal?.lng),
      };

      const origin = {
        lat: Number(data?.shipper?.lat),
        lng: Number(data?.shipper?.lng),
      };

      if (yard.lat && origin.lat) {
        getRouteDistance(yard, origin)
          .then(({ distanceKm, distanceMiles, directions }) => {
            setYardtoPichup(distanceMiles);
          })
          .catch(console.error);
      }
    }
  }, [atPickup]);

  return (
    <>
      {" "}
      {/* <div className="border mb-3">
        <h2 className="font-bold bg-gray-100 text-sm p-2">PICKUP - STOP#1</h2>

        <div className="flex gap-4 p-2">
          <div className="flex-1">
            <div className="mb-3">
              <h3 className="font-bold text-xs">Date</h3>
              <p className="text-xs text-gray-600">
                {moment(data?.pick_up_date).format("MM-DD-YYYY")}{" "}
                <strong className="font-bold text-black">Time -</strong>
                {data?.pick_up_starttime} - {data?.pick_up_endtime}
              </p>
            </div>
            <div className="mb-3">
              <h3 className="font-bold text-xs">{data?.shipper?.name}</h3>
              <p className="font-light text-xs">
                {data?.shipper?.address}, {data?.shipper?.city},{" "}
                {data?.shipper?.state}, {data?.shipper?.zipCode}
              </p>
            </div>
            <div className="mb-3">
              <p className="font-bold text-xs text-yellow-500">
                Location Notes:
              </p>
              <p className="font-light text-xs lowercase">
                {data?.shipper?.notes}
              </p>
            </div>

            <div className="mb-3">
              <h3 className="font-bold text-xs">Instructions:</h3>
              <p className="font-light text-xs">{data?.pick_up_instructions}</p>
            </div>
            <div className="mb-3">
              <h3 className=" text-xs mb-2">
                <strong>Stop Pickup:</strong>{" "}
                {!isEmpty(hookedTrailer)
                  ? hookedTrailer[0]?.status
                  : data?.pick_up_stop_pickup}
              </h3>
              <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                {yardtoPichup} Empty Miles
              </p>
            </div>

            <div className="flex space-x-2 mt-4 text-xs">
              <span className="bg-gray-200 px-1 py-1 rounded">
                In:
                {!isEmpty(atPickup) && (
                  <strong>
                    {moment(atPickup[0]?.createdAt).format("HH:mm A")}
                  </strong>
                )}
              </span>
              <span className="bg-gray-200 px-1 py-1 rounded text-center">
                Out:
                {!isEmpty(hookedTrailer) && (
                  <strong>
                    {moment(hookedTrailer[0]?.createdAt).format("HH:mm A")}
                  </strong>
                )}
                {!isEmpty(loadingComplete) && (
                  <strong>
                    {moment(loadingComplete[0]?.createdAt).format("HH:mm A")}
                  </strong>
                )}
              </span>
              <span className="bg-gray-200 px-1 py-1 rounded">Detention:</span>
            </div>
            <div className="flex space-x-2 mt-2 text-xs">
              <button className="bg-yellow-400 text-black px-2 py-1 rounded">
                Add Contacts
              </button>
            </div>
          </div>
          <div className="flex-1 ">
            <div className="mb-5 text-xs">
              <ul>
                <li>
                  <strong>Total Qty : </strong>
                  {data?.pick_up_total_quantity}
                </li>
                <li>
                  <strong>Total Weight : </strong>
                  {data?.pick_up_total_weight}
                </li>
                <li>
                  <strong>Commodity : </strong>
                  {data?.pick_up_commodity}
                </li>
                <li>
                  <strong>Route Name : </strong>
                  {data?.pick_up_route_name}
                </li>
              </ul>
            </div>
            <div className="mb-3 text-xs">
              <ul>
                <li>
                  <strong>Cutomer Load/Ref/Conf # : </strong>
                  {data?.pick_up_customer_load_ref}
                </li>
                <li>
                  <strong>Shipment BOL # : </strong>
                  {data?.pick_up_shipment_bol}
                </li>
                <li>
                  <strong>PO Number # : </strong>
                  {data?.pick_up_po_number}
                </li>
                <li>
                  <strong>Pickup # : </strong>
                  {data?.pickup}
                </li>
              </ul>
            </div>
            <div className="flex space-x-2 mt-4 text-xs">
              <button
                className="bg-green-500 text-white px-2 py-1 rounded"
                onClick={() => {
                  handleClick({
                    formId: "LoadShipper",
                    action: "create",
                    title: "Pick Up",
                  });
                }}
              >
                Split
              </button>
              <button
                className="bg-blue-500 text-white px-2 py-1 rounded"
                onClick={() => {
                  handleClick({
                    formId: "load",
                    sectionId: "pickup",
                    action: "edit",
                    title: "Pick Up",
                  });
                }}
              >
                Edit
              </button>
              <button className="bg-blue-500 text-white px-2 py-1 rounded">
                Add Commodity
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {data?.LoadShipper?.map((items: any, index: number) => {
        const oneBasedIndex = index + 1;
        return (
          <div className="border mb-3" key={index}>
            <h2 className="font-bold bg-gray-100 text-sm p-2">
              PICKUP - STOP#{oneBasedIndex}
            </h2>

            <div className="flex gap-4 p-2">
              <div className="flex-1">
                <div className="mb-3">
                  <h3 className="font-bold text-xs">Date</h3>
                  <p className="text-xs text-gray-600">
                    {moment(items?.pick_up_date).format("MM-DD-YYYY")}{" "}
                    <strong className="font-bold text-black">Time -</strong>
                    {items?.pick_up_starttime} - {items?.pick_up_endtime}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className="font-bold text-xs">{items?.shippers?.name}</h3>
                  <p className="font-light text-xs">
                    {items?.shippers?.address} {items?.shippers?.zipCode}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-bold text-xs text-yellow-500">
                    Location Notes:
                  </p>
                  <p className="font-light text-xs lowercase">
                    {items?.shippers?.notes}
                  </p>
                </div>

                <div className="mb-3">
                  <h3 className="font-bold text-xs">Instructions:</h3>
                  <p className="font-light text-xs">
                    {items?.pick_up_instructions}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className=" text-xs mb-2">
                    <strong>Stop Pickup:</strong>{" "}
                    {!isEmpty(hookedTrailer)
                      ? hookedTrailer[0]?.status
                      : data?.pick_up_stop_pickup}
                  </h3>
                  <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                    {yardtoPichup} Empty Miles
                  </p>
                </div>

                <div className="flex space-x-2 mt-4 text-xs">
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    In:
                    {!isEmpty(atPickup) && (
                      <strong>
                        {moment(atPickup[0]?.createdAt).format("HH:mm A")}
                      </strong>
                    )}
                  </span>
                  <span className="bg-gray-200 px-1 py-1 rounded text-center">
                    Out:
                    {!isEmpty(hookedTrailer) && (
                      <strong>
                        {moment(hookedTrailer[0]?.createdAt).format("HH:mm A")}
                      </strong>
                    )}
                    {!isEmpty(loadingComplete) && (
                      <strong>
                        {moment(loadingComplete[0]?.createdAt).format(
                          "HH:mm A",
                        )}
                      </strong>
                    )}
                  </span>
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    Detention:
                  </span>
                </div>
                <div className="flex space-x-2 mt-2 text-xs">
                  <button className="bg-yellow-400 text-black px-2 py-1 rounded">
                    Add Contacts
                  </button>
                </div>
              </div>
              <div className="flex-1 ">
                <div className="mb-5 text-xs">
                  <ul>
                    <li>
                      <strong>Total Qty : </strong>
                      {items?.pick_up_total_quantity}
                    </li>
                    <li>
                      <strong>Total Weight : </strong>
                      {items?.pick_up_total_weight}
                    </li>
                    <li>
                      <strong>Commodity : </strong>
                      {items?.pick_up_commodity}
                    </li>
                    <li>
                      <strong>Route Name : </strong>
                      {items?.pick_up_route_name}
                    </li>
                  </ul>
                </div>
                <div className="mb-3 text-xs">
                  <ul>
                    <li>
                      <strong>Cutomer Load/Ref/Conf # : </strong>
                      {items?.pick_up_customer_load_ref}
                    </li>
                    <li>
                      <strong>Shipment BOL # : </strong>
                      {items?.pick_up_shipment_bol}
                    </li>
                    <li>
                      <strong>PO Number # : </strong>
                      {items?.pick_up_po_number}
                    </li>
                    <li>
                      <strong>Pickup # : </strong>
                      {items?.pickup}
                    </li>
                  </ul>
                </div>
                <div className="flex space-x-2 mt-4 text-xs">
                  <button
                    className="bg-green-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      handleClick({
                        formId: "LoadShipper",
                        action: "create",
                        title: "Pick Up",
                      });
                    }}
                  >
                    Split
                  </button>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      handleClick({
                        formId: "LoadShipper",
                        action: "edit",
                        title: "Pick Up",
                      });
                    }}
                  >
                    Edit
                  </button>
                  <button className="bg-blue-500 text-white px-2 py-1 rounded">
                    Add Commodity
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {/* <div className="border">
        <h2 className="font-bold bg-gray-100 text-sm p-2">DELIVERY - STOP#2</h2>

        <div className="flex gap-4 p-2">
          <div className="flex-1">
            <div className="mb-3">
              <h3 className="font-bold text-xs">Date</h3>
              <p className="text-xs text-gray-600">
                {moment(data?.delivery_date).format("MM-DD-YYYY")}{" "}
                <strong className="font-bold text-black">Time -</strong>
                {data?.delivery_start_time} - {data?.delivery_end_time}
              </p>
            </div>
            <div className="mb-3">
              <h3 className="font-bold text-xs">{data?.consignee?.name}</h3>
              <p className="font-light text-xs">
                {data?.consignee?.address}, {data?.consignee?.city},{" "}
                {data?.consignee?.state}, {data?.consignee?.zipCode}
              </p>
            </div>
            <div className="mb-3">
              <p className="font-bold text-xs text-yellow-500">
                Location Notes :
              </p>
              <p className="font-light text-xs lowercase">
                {data?.consignee?.notes}
              </p>
            </div>

            <div className="mb-3">
              <h3 className="font-bold text-xs">Instructions : </h3>
              <p className="font-light text-xs">
                {data?.delivery_instructions}
              </p>
            </div>
            <div className="mb-3">
              <h3 className=" text-xs mb-2">
                <strong>Stop Delivery:</strong>{" "}
                {!isEmpty(unHook)
                  ? "Dropped Trailer"
                  : data?.delivery_stop_delivery}
              </h3>
              <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                0 Empty Miles
              </p>
            </div>

            <div className="flex space-x-2 mt-4 text-xs">
              <span className="bg-gray-200 px-1 py-1 rounded">
                In :{" "}
                {!isEmpty(AtDelivery) && (
                  <strong>
                    {moment(AtDelivery[0]?.createdAt).format("HH:mm A")}
                  </strong>
                )}
              </span>
              <span className="bg-gray-200 px-1 py-1 rounded">
                Out :{" "}
                {!isEmpty(delivered) && (
                  <strong>
                    {moment(delivered[0]?.createdAt).format("HH:mm A")}
                  </strong>
                )}
              </span>
              <span className="bg-gray-200 px-1 py-1 rounded">Detention :</span>
            </div>
            <div className="flex space-x-2 mt-2 text-xs">
              <button className="bg-yellow-400 text-black px-2 py-1 rounded">
                Add Contacts
              </button>
            </div>
          </div>
          <div className="flex-1 ">
            <div className="mb-5 text-xs">
              <ul>
                <li>
                  <strong>Total Qty : </strong>
                  {data?.delivery_total_quantity}
                </li>
                <li>
                  <strong>Total Weight : </strong>
                  {data?.delivery_total_weight}
                </li>
                <li>
                  <strong>Commodity : </strong>
                  {data?.delivery_commodity}
                </li>
              </ul>
            </div>
            <div className="mb-3 text-xs">
              <ul>
                <li>
                  <strong>Cutomer Load/Ref/Conf # : </strong>
                  {data?.delivery_customer_load_ref}
                </li>
                <li>
                  <strong>Shipment BOL # : </strong>
                  {data?.delivery_shipment_bol}
                </li>
                <li>
                  <strong>PO Number # : </strong>
                  {data?.delivery_po_number}
                </li>
                <li>
                  <strong>Pickup # : </strong>
                  {data?.delivery}
                </li>
              </ul>
            </div>
            <div className="flex space-x-2 mt-4 text-xs">
              <button
                className="bg-green-500 text-white px-2 py-1 rounded"
                onClick={() => {
                  handleClick({
                    formId: "LoadConsignee",
                    action: "create",
                    title: "Consignee",
                  });
                }}
              >
                Split
              </button>
              <button
                className="bg-blue-500 text-white px-2 py-1 rounded"
                onClick={() => {
                  handleClick({
                    formId: "load",
                    sectionId: "delivery",
                    action: "edit",
                    title: "Delivery",
                  });
                }}
              >
                Edit
              </button>
              <button className="bg-blue-500 text-white px-2 py-1 rounded">
                Add Commodity
              </button>
            </div>
          </div>
        </div>
      </div> */}
      {data?.LoadConsignee.map((items: any, index: number) => {
        const oneBasedIndex = index + 1;
        return (
          <div className="border">
            <h2 className="font-bold bg-gray-100 text-sm p-2">
              DELIVERY - STOP#{oneBasedIndex}
            </h2>

            <div className="flex gap-4 p-2">
              <div className="flex-1">
                <div className="mb-3">
                  <h3 className="font-bold text-xs">Date</h3>
                  <p className="text-xs text-gray-600">
                    {moment(items?.delivery_date).format("MM-DD-YYYY")}{" "}
                    <strong className="font-bold text-black">Time -</strong>
                    {items?.delivery_start_time} - {items?.delivery_end_time}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className="font-bold text-xs">{items?.shipper?.name}</h3>
                  <p className="font-light text-xs">
                    {items?.shipper?.address}, {items?.shipper?.zipCode}
                  </p>
                </div>
                <div className="mb-3">
                  <p className="font-bold text-xs text-yellow-500">
                    Location Notes :
                  </p>
                  <p className="font-light text-xs lowercase">
                    {items?.shipper?.notes}
                  </p>
                </div>

                <div className="mb-3">
                  <h3 className="font-bold text-xs">Instructions : </h3>
                  <p className="font-light text-xs">
                    {items?.delivery_instructions}
                  </p>
                </div>
                <div className="mb-3">
                  <h3 className=" text-xs mb-2">
                    <strong>Stop Delivery:</strong>{" "}
                    {!isEmpty(unHook)
                      ? "Dropped Trailer"
                      : data?.delivery_stop_delivery}
                  </h3>
                  <p className="font-bold text-xs bg-orange-100 px-2 py-1 rounded">
                    0 Empty Miles
                  </p>
                </div>

                <div className="flex space-x-2 mt-4 text-xs">
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    In :{" "}
                    {!isEmpty(AtDelivery) && (
                      <strong>
                        {moment(AtDelivery[0]?.createdAt).format("HH:mm A")}
                      </strong>
                    )}
                  </span>
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    Out :{" "}
                    {!isEmpty(delivered) && (
                      <strong>
                        {moment(delivered[0]?.createdAt).format("HH:mm A")}
                      </strong>
                    )}
                  </span>
                  <span className="bg-gray-200 px-1 py-1 rounded">
                    Detention :
                  </span>
                </div>
                <div className="flex space-x-2 mt-2 text-xs">
                  <button className="bg-yellow-400 text-black px-2 py-1 rounded">
                    Add Contacts
                  </button>
                </div>
              </div>
              <div className="flex-1 ">
                <div className="mb-5 text-xs">
                  <ul>
                    <li>
                      <strong>Total Qty : </strong>
                      {items?.delivery_total_quantity}
                    </li>
                    <li>
                      <strong>Total Weight : </strong>
                      {items?.delivery_total_weight}
                    </li>
                    <li>
                      <strong>Commodity : </strong>
                      {items?.delivery_commodity}
                    </li>
                  </ul>
                </div>
                <div className="mb-3 text-xs">
                  <ul>
                    <li>
                      <strong>Cutomer Load/Ref/Conf # : </strong>
                      {items?.delivery_customer_load_ref}
                    </li>
                    <li>
                      <strong>Shipment BOL # : </strong>
                      {items?.delivery_shipment_bol}
                    </li>
                    <li>
                      <strong>PO Number # : </strong>
                      {items?.delivery_po_number}
                    </li>
                    <li>
                      <strong>Pickup # : </strong>
                      {items?.delivery}
                    </li>
                  </ul>
                </div>
                <div className="flex space-x-2 mt-4 text-xs">
                  <button
                    className="bg-green-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      handleClick({
                        formId: "LoadConsignee",
                        action: "create",
                        title: "Consignee",
                      });
                    }}
                  >
                    Split
                  </button>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                    onClick={() => {
                      handleClick({
                        formId: "load",
                        sectionId: "delivery",
                        action: "edit",
                        title: "Delivery",
                      });
                    }}
                  >
                    Edit
                  </button>
                  <button className="bg-blue-500 text-white px-2 py-1 rounded">
                    Add Commodity
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default LoadPickAndDelivery;
